/* ============================================================
   Pholoh back-in-stock popup.
   Opens from the PDP "Size not in stock?" link, lists the sold-out
   sizes, and subscribes the shopper via Klaviyo's onsite Back-in-Stock
   endpoint so they get an email when their size restocks.

   Klaviyo public key resolution order:
     1. data-klaviyo-key on the modal (theme setting klaviyo_public_key)
     2. company_id from the loaded Klaviyo onsite script
     3. window.klaviyo / window._klOnsite company id
   ============================================================ */
(function () {
  'use strict';

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var lastFocus = null;

  function klaviyoKey(modal) {
    var explicit = (modal.getAttribute('data-klaviyo-key') || '').trim();
    if (explicit) return explicit;
    var s = document.querySelector('script[src*="klaviyo.js"], script[src*="klaviyo.com/onsite"]');
    if (s && s.src) {
      var m = s.src.match(/company_id=([^&]+)/);
      if (m) return decodeURIComponent(m[1]);
    }
    if (window.klaviyo && window.klaviyo.company_id) return window.klaviyo.company_id;
    if (window._klOnsite && window._klOnsite.company_id) return window._klOnsite.company_id;
    return '';
  }

  function findModal(btn) {
    var sec = btn.closest('[data-section-id]');
    return (sec && sec.querySelector('[data-pholoh-bis]')) || document.querySelector('[data-pholoh-bis]');
  }

  function open(modal) {
    lastFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    // force reflow so the CSS transition runs
    void modal.offsetWidth;
    modal.classList.add('is-open');
    document.documentElement.classList.add('pholoh-bis-lock');
    // preselect when there's only one sold-out size
    if (modal.dataset.single === '1') {
      var only = modal.querySelector('.pholoh-bis__size');
      if (only) selectSize(only);
    }
    var focusTarget = modal.querySelector('.pholoh-bis__size.is-selected') ||
      modal.querySelector('.pholoh-bis__size') || modal.querySelector('[data-pholoh-bis-close]');
    if (focusTarget) focusTarget.focus();
  }

  function close(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pholoh-bis-lock');
    var done = function () {
      modal.hidden = true;
      modal.removeEventListener('transitionend', done);
    };
    modal.addEventListener('transitionend', done);
    // fallback if no transition fires
    setTimeout(function () { if (!modal.classList.contains('is-open')) modal.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function selectSize(btn) {
    var modal = btn.closest('[data-pholoh-bis]');
    if (!modal) return;
    modal.querySelectorAll('.pholoh-bis__size').forEach(function (b) {
      b.classList.toggle('is-selected', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    modal.dataset.variant = btn.getAttribute('data-bis-variant') || '';
    modal.classList.add('is-ready');
    var msg = modal.querySelector('[data-pholoh-bis-msg]');
    if (msg) msg.textContent = '';
    var email = modal.querySelector('[data-pholoh-bis-email]');
    if (email && !email.value) email.focus();
  }

  function subscribe(modal) {
    var variant = modal.dataset.variant;
    var emailEl = modal.querySelector('[data-pholoh-bis-email]');
    var msg = modal.querySelector('[data-pholoh-bis-msg]');
    var submit = modal.querySelector('[data-pholoh-bis-submit]');
    var email = emailEl ? emailEl.value.trim() : '';

    msg.className = 'pholoh-bis__msg';
    if (!variant) { msg.textContent = 'Pick a size first.'; return; }
    if (!EMAIL_RE.test(email)) { msg.textContent = 'Enter a valid email address.'; emailEl.focus(); return; }

    var key = klaviyoKey(modal);
    if (!key) {
      msg.textContent = "Back-in-stock isn't set up yet — try again soon.";
      msg.classList.add('is-error');
      return;
    }

    submit.disabled = true;
    submit.classList.add('is-loading');
    msg.textContent = '';

    var body = 'a=' + encodeURIComponent(key) +
      '&email=' + encodeURIComponent(email) +
      '&variant=' + encodeURIComponent(variant) +
      '&platform=shopify';

    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache' },
      body: body
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (res.ok && res.data && res.data.success !== false) {
          modal.classList.add('is-done');
          msg.textContent = "You're on the list — we'll email you the moment it's back.";
          msg.classList.add('is-ok');
        } else {
          var err = res.data && res.data.errors && res.data.errors[0];
          msg.textContent = err || 'Something went wrong — please try again.';
          msg.classList.add('is-error');
          submit.disabled = false;
        }
      })
      .catch(function () {
        msg.textContent = 'Network error — please try again.';
        msg.classList.add('is-error');
        submit.disabled = false;
      })
      .then(function () { submit.classList.remove('is-loading'); });
  }

  function init() {
    // Move each modal to <body> so position:fixed is never trapped by a
    // transformed/overflow ancestor in the product blocks.
    document.querySelectorAll('[data-pholoh-bis]').forEach(function (m) {
      if (m.parentElement !== document.body) document.body.appendChild(m);
    });

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-pholoh-bis-open]');
      if (openBtn) { e.preventDefault(); var m = findModal(openBtn); if (m) open(m); return; }

      var closeBtn = e.target.closest('[data-pholoh-bis-close]');
      if (closeBtn) { var mc = closeBtn.closest('[data-pholoh-bis]'); if (mc) close(mc); return; }

      var sizeBtn = e.target.closest('.pholoh-bis__size');
      if (sizeBtn) { selectSize(sizeBtn); return; }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-pholoh-bis-form]');
      if (!form) return;
      e.preventDefault();
      var modal = form.closest('[data-pholoh-bis]');
      if (modal) subscribe(modal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openModal = document.querySelector('[data-pholoh-bis].is-open');
      if (openModal) close(openModal);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
